import React from 'react';
import { ShowingDetails } from '../models/api';
import DeleteButton from './DeleteButton';
import Button from './Button';
import { FaEllipsisH } from 'react-icons/fa';
import { ReactComponent as DeleteIcon } from '../assets/delete_large.svg';
import { ReactComponent as EditIcon } from '../assets/edit_large.svg';
import { ReactComponent as PresentIcon } from '../assets/present_to_all_large.svg';

type Props = {
  index: number;
  selectedIndex: number | null;
  showingDetails: ShowingDetails;
  onToggle: ((index: number) => void) | ((index: number) => Promise<void>);
  onEdit:
    | ((showingDetails: ShowingDetails) => void)
    | ((showingDetails: ShowingDetails) => Promise<void>);
  navigateToPresent:
    | ((showingDetails: ShowingDetails) => void)
    | ((showingDetails: ShowingDetails) => Promise<void>);
  onDelete:
    | ((showingDetails: ShowingDetails) => void)
    | ((showingDetails: ShowingDetails) => Promise<void>);
  deleteLoading: string[];
};

const ShowingContextMenu: React.FC<Props> = ({
  index,
  selectedIndex,
  showingDetails,
  onDelete,
  onEdit,
  onToggle,
  navigateToPresent,
  deleteLoading
}) => {
  return (
    <>
      <Button
        isIcon={true}
        className="menu-button"
        onClick={() => onToggle(index)}
      >
        <FaEllipsisH />
      </Button>
      {selectedIndex === index && (
        <div className="card-menu">
          <Button
            className="card-menu-item"
            onClick={() => onEdit(showingDetails)}
          >
            <EditIcon />
            Edit
          </Button>
          <Button
            className="card-menu-item"
            onClick={() => navigateToPresent(showingDetails)}
          >
            <PresentIcon /> Present
          </Button>
          <hr />
          <DeleteButton
            isLoading={deleteLoading.includes(showingDetails.reference)}
            onClick={() => onDelete(showingDetails)}
            message="Are you sure you want to delete this showing?"
            className="card-menu-item delete"
          >
            <DeleteIcon /> Delete
          </DeleteButton>
        </div>
      )}
    </>
  );
};

export default ShowingContextMenu;
